module.exports = __webpack_public_path__ + "static/ss-mock-38d14f45f243b7d2d80fdd3c56de042c.png";